import type { SizeType } from './interfaces';

export const SIZES: Record<SizeType, number> = {
  DEFAULT: 142,
  NARROW: 86,
  PROMOTED: 182,
  LIGHT: 150,
  VERTICAL_LIGHT: 158,
};
